/* eslint-disable camelcase */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ClientIcon from "../../../../images/reportIcons/client-report.svg?svgr";
import InvoiceIcon from "../../../../images/reportIcons/invoice-report.svg?svgr";
import LocationIcon from "../../../../images/reportIcons/location-report.svg?svgr";
import OfficerIcon from "../../../../images/reportIcons/officer-report.svg?svgr";
import ReceiptIcon from "../../../../images/reportIcons/payment-report.svg?svgr";
import TransactionIcon from "../../../../images/reportIcons/transaction-report.svg?svgr";
import AgencyIcon from "../../../../images/reportIcons/agency-report.svg?svgr";
import DefaultIcon from "../../../../images/reportIcons/custom-report.svg?svgr";
import HomeIcon from "../../../../images/reportIcons/home-grid.svg?svgr";
import RollKallIcon from "../../../../images/reportIcons/rollkall-report.svg?svgr";

const report_icons = {
	client: ClientIcon,
	invoice: InvoiceIcon,
	location: LocationIcon,
	officer: OfficerIcon,
	receipt: ReceiptIcon,
	transaction: TransactionIcon,
	agency: AgencyIcon,
	default: DefaultIcon,
	home: HomeIcon,
    rollkall: RollKallIcon
};

class ReportSidebar extends Component {
	onReportChange = event => {
		const {
			setReports,
			setReportState,
			resetFilters,
			resetReportParams,
			generateReportBtnCallback,
			reports,
		} = this.props;

		resetFilters(() =>
			setReportState({
				reportType: event?.label || "",
				reportId: event?.id || "",
				reportSource: event?.source || "domo",
				renderReport: false,
			}),
		);

		setReports({ reports });

		resetReportParams();
		// Ensuring state is selected
		setTimeout(() => {
			generateReportBtnCallback();
		}, 100);
	};

	render() {
		const { lang } = global;

		const { reportType, reports, smallIcons, restoreReportGrid } = this.props;

		return (
			<Fragment>
				<label
					htmlFor="rollkall-reports"
					className="domo-sidebar-title"
				>
					{!smallIcons ? lang.t("RollKall Reports") : " "}
				</label>
				<div className="flex flex-align-items-center flex-justify-content-space-between margin-bottom-20">
					<div className="domo-report-list">
						<div
							className={`report-item restore-report-grid ${smallIcons ? "small-icon" : "big-icon"}`}
						>
							<div
								role="presentation"
								value=""
								onClick={() => restoreReportGrid()}
								onKeyDown={() => restoreReportGrid()}
								className="restore-grid-button"
							>
								<div>
									{React.createElement(report_icons.home, {
										className: "report-picker-icon small-icon",
									})}{" "}
									{!smallIcons ? "Home" : ""}
								</div>
							</div>
						</div>
						<For
							each="report"
							index="index"
							of={reports}
						>
							<div
								className={`report-item ${report.label === reportType ? "active" : ""} ${smallIcons ? "small-icon" : ""}`}
							>
								<div
									role="presentation"
									value={report}
									onClick={() => {
										this.onReportChange(report);
									}}
									onKeyDown={() => {
										this.onReportChange(report);
									}}
								>
									<div>
										{React.createElement(
											report_icons[report.category] || report_icons.default,
											{
												className: "report-picker-icon small-icon",
											},
										)}{" "}
										{!smallIcons ? report.label : ""}
									</div>
								</div>
							</div>
						</For>
					</div>
				</div>
			</Fragment>
		);
	}
}

ReportSidebar.propTypes = {
	generateReportBtnCallback: PropTypes.func.isRequired,
	resetReportParams: PropTypes.func.isRequired,
	reports: PropTypes.array,
	reportType: PropTypes.string,
	setReports: PropTypes.object.isRequired,
	setReportState: PropTypes.func.isRequired,
	smallIcons: PropTypes.bool,
	resetFilters: PropTypes.func.isRequired,
	restoreReportGrid: PropTypes.func.isRequired,
};

ReportSidebar.defaultProps = {
	reportType: "",
	reports: [],
	smallIcons: false,
};
export default ReportSidebar;
